import { useEffect } from 'react';

import { useRouter } from 'next/router';
import ThumbnailImage from 'src/components/thumbnail/components/ThumbnailImage';
import { ThumbnailTypes } from 'src/components/thumbnail/types';
import { railsPropertySetter } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { thumbnailPropertySetter } from 'src/utils/analytics/mixpanel/propertySetter';
import {
  generateCardsUrl,
  navigationHandler
} from 'src/utils/cardsUrlGenerator';
import { DynamicObject } from 'src/utils/commonTypes';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';
import { RailsMixpanelPayload } from 'src/utils/railsMixpanelPayloadTypes';
import { railsReducer } from 'src/utils/railsReducerHelper/railsReducer';

import { useAppStore } from 'src/hooks/useAppStore';
import { globalUrlHelper } from '../../../utils/common';
import { EXPLORE_MORE } from '../../../utils/constants/stringConstants';
import * as customStyled from './SearchLandingStyle';

interface ExploreNowInterface {
  data: DynamicObject | undefined;
  hideMenu: boolean;
  content: ContentMetaData;
  isSearchLanding: boolean;
  verticalIndex: number;
  mixpanelPayload: RailsMixpanelPayload;
}
export const ExploreNow = (props: ExploreNowInterface) => {
  const {
    data,
    hideMenu,
    content,
    isSearchLanding,
    verticalIndex,
    mixpanelPayload
  } = props;

  const { appConfig } = useAppStore();
  const deviceWidth = appConfig?.deviceWidth || 0;
  const router = useRouter();
  const railIDsAndRailElements = railsReducer(content);
  let pageRailImpressionTriggered = false;

  useEffect(() => {
    triggerRailImpression();
  }, []);
  const triggerRailImpression = () => {
    if (!pageRailImpressionTriggered) {
      railsPropertySetter(mixpanelPayload, isSearchLanding);
      pageRailImpressionTriggered = true;
    }
  };

  return (
    <div css={customStyled.exploreNowContainer}>
      <h2>{content?.title || EXPLORE_MORE}</h2>
      <div css={customStyled.exploreNowWrapper}>
        {data &&
          data.map((item: ContentMetaData, index: number) => {
            const formattedItem = {
              id: item?.id,
              title: item?.title,
              assetType: item?.assetType,
              image: item?.image
            };
            const cardDetails = {
              contentId: content?.id,
              title: item?.title || '',
              horizontalIndex: index + 1,
              verticalIndex: verticalIndex + 1,
              modelName: props.content?.modelName,
              assetSubtype: content?.assetSubType,
              originalTitle: content?.originalTitle,
              railIds: railIDsAndRailElements?.railIds,
              railElements: railIDsAndRailElements?.railElements
            };
            const imageUrl = getImageURL({
              deviceWidth,
              tagName: TAG_NAME.PORTRAIT_SMALL,
              item: formattedItem
            });
            let slugData = generateCardsUrl(item);

            const watchCallback = (e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              thumbnailPropertySetter({
                item: {
                  imageUrl,
                  title: isSearchLanding
                    ? cardDetails.originalTitle
                    : formattedItem.title,
                  cardDetails,
                  assetSubtype: cardDetails.assetSubtype,
                  isSearchLanding
                }
              });
              if (slugData) {
                slugData = slugData.startsWith('/') ? slugData : `/${slugData}`;
                navigationHandler(slugData, (slugData) => {
                  // commenting router.push might not available while redirecting to PWA page.
                  // router.push(slugData, slugData);
                  if (typeof window !== 'undefined') {
                    window.location.href = globalUrlHelper(slugData, true);
                  }
                });
              }
            };
            return (
              <div key={index} css={customStyled.thumbnailImageStyle(hideMenu)}>
                <ThumbnailImage
                  imageUrl={imageUrl}
                  assetType={item.assetType}
                  slug={slugData || ''}
                  businessType={item?.businessType as string}
                  billingType={item?.billingType as string}
                  onClickHandler={watchCallback}
                  thumbnailType={ThumbnailTypes.vertical}
                  title={item?.title}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
